import moment from 'moment';

/**
 * 組織取得APIに渡す対象日を計算する
 *
 * @param fromDate - 開始日
 * @param toDate - 終了日
 * @returns 計算された開始日と終了日のオブジェクト
 *
 * ロジック:
 * - fromDate～toDateの期間内に現在日が含まれている場合 → 両方とも当日を返す
 * - 期間が現在日より未来の場合 → 両方とも当日を返す
 * - 期間が現在日より過去の場合 → 引数のfromDate, toDateをそのまま返す
 *
 * @example
 * // 当月の期間を指定した場合（現在日が含まれる）
 * const result = getOrgTargetDates(new Date('2025-11-01'), new Date('2025-11-30'));
 * // → { from: 今日の日付, to: 今日の日付 }
 *
 * @example
 * // 未来月の期間を指定した場合（現在日より未来）
 * const result = getOrgTargetDates(new Date('2025-12-01'), new Date('2025-12-31'));
 * // → { from: 今日の日付, to: 今日の日付 }
 *
 * @example
 * // 過去月の期間を指定した場合（現在日より過去）
 * const result = getOrgTargetDates(new Date('2025-10-01'), new Date('2025-10-31'));
 * // → { from: 2025-10-01, to: 2025-10-31 }
 */
export const getOrgTargetDates = (fromDate: Date, toDate: Date): { from: Date; to: Date } => {
  const today = new Date();

  // 現在日が期間内に含まれているか判定
  const isWithinPeriod = moment(today).isBetween(
    moment(fromDate).startOf('day'),
    moment(toDate).endOf('day'),
    undefined,
    '[]', // 境界を含む
  );

  // 期間が現在日より未来かどうか判定
  //   const isFuturePeriod = moment(fromDate).isAfter(moment(today).endOf('day'));

  //   if (isWithinPeriod || isFuturePeriod) {
  if (isWithinPeriod) {
    // 期間内に現在日が含まれている、または期間が未来 → 当日を返す
    return { from: fromDate, to: today };
  }

  // 期間が過去 → 引数をそのまま返す
  return { from: fromDate, to: toDate };
};

export default getOrgTargetDates;
